import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { useEffect, useState } from "react";
import { Fetch } from "../../shared/Fetch";
import { JVCheck } from "../../shared/JVCheck";
import { IClientTnfr } from "../clientTransfer/ClientTnfr";
import { Dialog } from "primereact/dialog";
import { IUsersDropdown } from "../../models/IDropdown";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { JVDropdown } from "../../shared/JVDropdown";

interface Iprops {
    toast: any,
    reload: boolean,
    setReload: (is: boolean) => void,
    open: boolean,
    hideDialog: () => void,
}

const schema = yup.object({
    salesPersonFrom: yup.number().required("Select Sales Manager From").min(1, "Select Sales Manager From"),
    salesPersonTo: yup.number().required("Select Sales Manager To").min(1, "Select Sales Manager To")
});

export const MultipleTransferHead = (props: Iprops) => {
    const [loading, setLoading] = useState(false);
    const [salesFrom, setSalesFrom] = useState<Array<IUsersDropdown>>();
    const [salesTo, setSalesTo] = useState<Array<IUsersDropdown>>();
    const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<IClientTnfr>, loading: boolean });
    const [selectedClients, setSelectedClients] = useState<Array<number>>([]);

    const { control, handleSubmit, watch, formState: { errors }, reset } = useForm<{ salesPersonFrom: number, salesPersonTo: number }>({
        resolver: yupResolver(schema),
        defaultValues: { salesPersonFrom: 0, salesPersonTo: 0 },
        shouldFocusError: false
    });

    useEffect(() => {
        const subscription = watch((value, { name, type }) => {
            if (name === "salesPersonFrom" && value.salesPersonFrom) loadTableData(value.salesPersonFrom);
        });
        return () => subscription.unsubscribe();
    }, [watch]);

    useEffect(() => {
        loadSalesFrom();
        loadSalesTo();
    }, []);

    const loadTableData = async (salesPerson: number) => {
        setTableData({ tableData: [], loading: true });
        const response = await Fetch("Sub_Vendor_Contact_Person_Mast/sm", "GET", null, `salesPerson=${salesPerson}`, props.toast);
        if (response) {
            const data: any = await response.json();
            setTableData({ tableData: data, loading: false });
        } else setTableData({ tableData: [], loading: false });
    }

    const loadSalesFrom = async () => {
        const response = await Fetch("Dropdown/UsersByBranch", "GET", null, `branch_ID=${0}&role_id=${2}`, null);
        if (response) {
            const data: Array<IUsersDropdown> = await response.json();
            setSalesFrom(data);
        }
    }
    const loadSalesTo = async () => {
        const response = await Fetch("Dropdown/Userslist", "GET", null, `company_id=${0}&role_id=${2}`, null);
        if (response) {
            const data: Array<IUsersDropdown> = await response.json();
            setSalesTo(data);
        }
    }

    const selectHead = () => {
        return (
            <span onClick={() => {
                if (tableData.tableData.length === selectedClients.length) {
                    setSelectedClients([]);
                } else {
                    const temp: Array<number> = [];
                    tableData.tableData.forEach((data) => {
                        if (data.contact_Person_Id) temp.push(data.contact_Person_Id)
                    });
                    setSelectedClients(temp);
                }
            }}>
                <JVCheck name="select_all_clients" defaultValue={tableData.tableData.length > 0 && tableData.tableData.length === selectedClients.length}></JVCheck>
            </span>
        );
    }
    const onSelect = (rowData: IClientTnfr) => {
        if (rowData.contact_Person_Id) {
            if (selectedClients.includes(rowData.contact_Person_Id)) {
                const temp = selectedClients.filter((t) => { return t !== rowData.contact_Person_Id });
                setSelectedClients(temp);
            } else {
                const temp = [...selectedClients];
                temp.push(rowData.contact_Person_Id);
                setSelectedClients(temp);
            }
        }
    }

    const select = (rowData: IClientTnfr) => {
        return (<span onClick={() => onSelect(rowData)}>
            <JVCheck name={rowData.contact_Person_EmailID} defaultValue={rowData.contact_Person_Id !== undefined && selectedClients.includes(rowData.contact_Person_Id)}></JVCheck>
        </span>
        );
    }

    const transferClients = async (data: { salesPersonFrom: number, salesPersonTo: number }) => {
        setLoading(true);
        const contact: Array<{ contactPersonID?: number }> = [];
        selectedClients.forEach(client => {
            contact.push({ contactPersonID: client });
        });
        const response = await Fetch("Sub_Vendor_Contact_Person_Mast/mutualClients", "POST", null, `salesManagerFrom=${data.salesPersonFrom}&salesManagerTo=${data.salesPersonTo}&contactPersons=${JSON.stringify(contact)}`, props.toast);
        if (response) {
            props.toast.current.show({ severity: 'success', content: "Client Transfered Successfully." });
            onHide();
            props.setReload(!props.reload);
        }
        setLoading(false);
    }

    function onSubmit(data: { salesPersonFrom: number, salesPersonTo: number }) {
        if (selectedClients.length > 0) transferClients(data);
        else props.toast.current.show({ severity: 'error', detail: "Select Client Contact Person to Transfer.", life: 3000 });
    }
    const onHide = () => {
        props.hideDialog();
        reset();
        setSelectedClients([]);
        setTableData({ tableData: [], loading: false });
    }

    return (
        <Dialog visible={props.open} style={{ width: '80vw' }} header="Transfer Multiple Client Contact Persons" className="p-fluid" onHide={onHide}>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid mb-3">
                <JVDropdown column={3} label="Sales Manager From" control={control} name="salesPersonFrom" options={salesFrom} optionLabel="user_Name" optionValue="login_ID" placeholder="Select Sales Manager From" error={errors.salesPersonFrom?.message} />
                <JVDropdown column={3} label="Sales Manager To" control={control} name="salesPersonTo" options={salesTo} optionLabel="user_Name" optionValue="login_ID" placeholder="Select Sales Manager To" error={errors.salesPersonTo?.message} />
                <div className="field col-12 md:col-4">
                    <label htmlFor="">&nbsp;</label>
                    <Button loading={loading} label="TRANSFER" type="submit"></Button>
                </div>
            </form>
            <DataTable style={{ border: '1px solid rgba(105,105,105,0.5)', borderTopWidth: "0" }}
                size="small" value={tableData.tableData} loading={tableData.loading} showGridlines
            >
                <Column field="select" header={selectHead} body={select} />
                <Column field="contact_Person_Name" header="Contact Person" style={{ minWidth: '12rem' }} sortable />
                <Column field="vendor_Company_Name" header="Company Name" style={{ minWidth: '14rem' }} sortable />
                <Column field="city_Name" header="City" style={{ minWidth: '8rem' }} />
                <Column field="state_Name" header="State" style={{ minWidth: '2rem' }} />
                <Column field="salesPerson" header="Sales Person" style={{ minWidth: '10rem' }} sortable />
            </DataTable>
        </Dialog>
    );
}
